import React from 'react';
import RuleModal from '../RuleModal';
import useCreateRuleModalLogic, { HookProps } from './useCreateRuleModalLogic';

const CreateRuleModal = (props: HookProps) => {
  const { busy, rule, handleSubmit } = useCreateRuleModalLogic(props);

  return (
    <RuleModal
      rule={rule}
      title="Create Rule"
      {...props}
      busy={busy}
      onSubmit={handleSubmit}
    />
  );
};

export default CreateRuleModal;
